import PageHeader from '@/global/components/PageHeader';
import { wrapperSx } from '@/global/helpers/globalstyles';
import React from 'react';
import { TransactionTable } from '@/modules/schools/tables/TransactionTable';
import { useParams } from 'react-router-dom';
import { Box, Button, Stack } from '@mui/material';
import { BalanceWidget } from '@/modules/schools';
import { apiGetSchoolById } from '@/modules/schools/services/school.service';
import { useUserStore } from '@/global/store/UserStore';
import { useModal } from '@/global/providers/ModalProvider';
import { SchoolChangeBalanceDialog } from '@/modules/schools/modals/SchoolChangeBalanceDialog';
import { SchoolLogsTable } from '@/modules/school-logs';

export function SchoolTransactionPage() {
    const {id} = useParams();

    const {data: schoolInfo} = apiGetSchoolById(+(id ?? 0));

    const isSuperAdmin = useUserStore((state) => state.isSuperAdmin);

    const isAdmin = useUserStore((state) => state.isAdmin || state.isSuperAdmin);

    const {openModal} = useModal();

    const openChangeBalanceDialog = () => {
        openModal(SchoolChangeBalanceDialog, {schoolId: +(id ?? 0)}, `school_change_balance_${id}`);
    };

    return (
        <Box
            className="App"
            sx={{height: '100%', display: 'flex', flexDirection: 'column', pb: 3}}
        >
            <PageHeader/>
            <Box sx={wrapperSx}>
                {
                    isSuperAdmin && (
                        <Stack
                            sx={{
                                alignItems: 'flex-end'
                            }}
                        >
                            <Button
                                onClick={openChangeBalanceDialog}
                                variant="contained"
                            >
                                Изменить баланс школы
                            </Button>
                        </Stack>
                    )}
                {
                    (isAdmin || !!schoolInfo?.is_can_buy_certificate || !!schoolInfo?.data.enableAiTest) && (
                        <Box
                            sx={{
                                marginTop: 2
                            }}
                        >
                            <BalanceWidget schoolInfo={schoolInfo}/>
                        </Box>
                    )}
                <TransactionTable id={+(id ?? 0)}/>
                {
                    isSuperAdmin && <SchoolLogsTable id={+(id ?? 0)}/>
                }
            </Box>
        </Box>
    );
}